import { AnchorBasic } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledZellerPricing = styled(AnchorBasic)`
  width: 15rem;
`
export const StyledZellerPricingContainer = styled.div`
  padding-bottom: 1.25rem;
`
